export default class Slider {
    constructor(slider, type) {
        this.slider = slider
        this.type = type
        console.log(type)

        if (this.type === "triple") this.triple()
    }

    triple() {
        this.sliderTripple = new Swiper(`#${this.slider.id}`, {
            slidesPerView: 1,
            spaceBetween: 16,
            slidesPerGroup: 1,
            navigation: {
                prevEl: `#${this.slider.id} [data-slider-prev]`,
                nextEl: `#${this.slider.id} [data-slider-next]`,
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        });
    }
}
